// extracted by mini-css-extract-plugin
export default {"header":"Eula_header__XOR61","headerTitle":"Eula_headerTitle__U4TZo","container":"Eula_container__Syop+","containerFooter":"Eula_containerFooter__TIEJh"};